<section>
  <app-datatable
    [columns]="columns"
    [dataUrl]="dataUrl"
    [defaultSort]="defaultSort"
    [scrollV]="false"
    [scrollH]="true"
    [preventInitialLoad]="true"
    [disableFiltering]="false"
    emptyMessage="There are no active Prior Authorization Requests."
    [rowClass]="getRowClass"
    [exportFileName]="'My PARs Queue'"
  ></app-datatable>

  <ng-template #idTemplate let-row="row" let-value="value">
    <a
      class="mat-button-link"
      tabindex="0"
      [routerLink]="[AppUrls.priorAuthorization.details(row.priorAuthorizationId)]"
    >
      <span class="visually-hidden">Navigate to Prior Auth</span>
      {{ value | entityFormatter: priorAuthTypeCode }}
    </a>
  </ng-template>

  <ng-template #injuryDateTemplate let-row="row" let-value="value">
    {{ row.dateOfInjuryDisplay }}
  </ng-template>
</section>
